import { render, staticRenderFns } from "./AdminAccounts.vue?vue&type=template&id=120d5ede&"
import script from "./AdminAccounts.vue?vue&type=script&lang=ts&"
export * from "./AdminAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports